import React from 'react';
import { useStowageStore } from 'src/context/StowageContext';
import SelectTankPlanConditionComponent from '../tankPlanView/selectTankPlanCondition/SelectTankPlanCondition';
import SelectTankPlanFilterComponent from '../tankPlanView/SelectTankPlanFilter/SelectTankPlanFilter';
import { PanelContent, PanelSectionContent } from 'src/components/ui/odfjellPanel/OdfjellPanel.styles';
import { TankplanFilters } from 'src/pages/stowage/StowagePage.styles';
import OdfjellPanel, { PANEL_CONSTANTS } from 'src/components/ui/odfjellPanel/OdfjellPanel';
import { TankPlanCondition } from 'src/enums/stowage/tankPlanCondition';
import { usePositionFromClick } from 'src/hooks/stowage/usePositionFromClick';
import { PanelDimensions } from 'src/types/ViewModel/Stowage/PanelDimensions';

const TankPlanFilterPanelComponent: React.FC = () => {
    const { isTankPlanFilterPanelOpen, setIsTankPlanFilterPanelOpen, setSelectedTankPlanCondition, setSelectedTankPlanFilters, mouseClickPosition } =
        useStowageStore();

    // Define panel dimensions for position calculation
    const panelDimensions: PanelDimensions = {
        width: PANEL_CONSTANTS.SMALL_WIDTH,
        height: 350, // Estimate the panel height
    };

    // Use the hook to calculate optimal position
    const panelPosition = usePositionFromClick(mouseClickPosition, panelDimensions);

    const onClose = () => {
        setIsTankPlanFilterPanelOpen(false);
    };

    const onClearFilter = () => {
        setSelectedTankPlanCondition(TankPlanCondition.Departure);
        setSelectedTankPlanFilters([]);
        setIsTankPlanFilterPanelOpen(false);
    };

    return (
        isTankPlanFilterPanelOpen && (
            <OdfjellPanel
                headerTitle={'Tank plan filters'}
                defaultPosition="center"
                initialPosition={mouseClickPosition ? panelPosition : undefined}
                panelWidth={PANEL_CONSTANTS.SMALL_WIDTH}
                onCancel={onClose}
                onAction={onClearFilter}
                actionButtonText="Clear"
                showCancelButton={true}
                cancelButtonText="Cancel"
            >
                <PanelSectionContent>
                    <PanelContent>
                        <TankplanFilters>
                            <li className="dd-item">
                                <SelectTankPlanConditionComponent />
                            </li>
                            <li className="dd-item">
                                <SelectTankPlanFilterComponent />
                            </li>
                        </TankplanFilters>
                    </PanelContent>
                </PanelSectionContent>
            </OdfjellPanel>
        )
    );
};

export default TankPlanFilterPanelComponent;
